import { initAdminPostCalendar } from "../components/AdminPostCalendar";

export const AdminPostController = {
    index(): void {},
    calendar(): void {
        const page = document.querySelector<HTMLElement>(".admin-posts--calendar");
        if (page) initAdminPostCalendar(page);
    },
    create(): void {},
    store(): void {},
    order(): void {},
    edit(): void {},
    update(): void {},
    bulkDestroy(): void {},
    destroy(): void {},
    move(): void {},
    togglePin(): void {},
};
